import classNames from 'classnames';
import React from 'react';

import { Checkbox, SvgIconUrl } from 'common/components';

import { memoizedComponent } from 'utils/memoizeComponent';

import { DropdownOption, DropdownOptionValue } from './Dropdown.component';

interface DropdownCheckboxProps<T> {
  option: DropdownOption<T>;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isActive?: boolean;
}

export const DropdownCheckbox = memoizedComponent(
  <T extends DropdownOptionValue>({ option, isActive = false, onClick }: DropdownCheckboxProps<T>) => {
    const _isActive = React.useMemo(() => isActive || option.checked, [isActive, option.checked]);

    const className = classNames({
      dropdown__item: true,
      'dropdown__item--checkbox': true,
      'dropdown__item--active': _isActive,
    });
    const labelClassName = classNames({
      'dropdown__item-label': true,
      'dropdown__item-label--checkbox': true,
      'dropdown__item-label--active': _isActive,
    });

    if (!option || option.hidden) return null;

    return (
      <div data-id={option['data-test']} data-test='dropdown-option' onClick={onClick} className={className}>
        <Checkbox checked={_isActive} className='dropdown__checkbox' iconStyle='semi-rounded'>
          <div className='dropdown__checkbox-label'>
            {option.icon && <SvgIconUrl className='dropdown__item-icon' symbol={option.icon} />}
            <span className={labelClassName}>{option.label}</span>
          </div>
        </Checkbox>
      </div>
    );
  },
);
